// import fontawesome from '@fortawesome/fontawesome'
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { fas, faOtter } from '@fortawesome/free-solid-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// fontawesome.library.add(far, fab, fas)

import classes from './vendors/helpers/classes';
import array_remove from './vendors/helpers/array_remove';
import events from './vendors/helpers/events';
import closest from './vendors/pollyfills/Element/closest';
import wamediabox from './libs/wa-mediabox';


import SliderHeaderHero from './Components/Slides/SliderHeaderHero';
import SliderStepByStep from "./Components/Slides/SliderStepByStep";
import SliderBlogBanner from "./Components/Slides/SliderBlogBanner";
import SliderRecommendedProducts from "./Components/Slides/SliderRecommendedProducts";
import SliderCompareProducts from "./Components/Slides/SliderCompareProducts";
import SliderPosts from "./Components/Slides/SliderPosts";


import Menu from "./Components/Menu";
import Toggle from "./Components/Toggle";
import Faq from "./Components/Faq";
import Dropdown from "./Components/Dropdown";
import Tabs from "./Components/Tabs";
import VideoPlayer from "./Components/VideoPlayer";
import Header from "./Components/Header";
import ScrollNextSection from "./Components/ScrollNextSection";
import ScrollTop from "./Components/ScrollTop";
// import Timeline from "./Components/Timeline";
import MenuProducts from "./Components/MenuProducts";
import MenuMobile from "./Components/MenuMobile";
import FormSuccess from "./Components/FormSuccess";
import Configurator from "./Components/Configurator";
import CompareProducts from "./Components/CompareProducts";
import CompareProductsMobile from "./Components/CompareProductsMobile";
import CompareProductButton from "./Components/CompareProductButton";
import App from "./App/App";
import LoadMore from "./Components/LoadMore";
import ChangeLink from "./Components/ChangeLink";
import AddToCart from "./Components/AddToCart";
import ColorPreview from "./Components/ColorPreview";
import RemoveProductCart from "./Components/RemoveProductCart";
import SearchSuggest from "./Components/SearchSuggest";
import SetVH from "./Components/SetVH";
import TriggerElement from "./Components/TriggerElement";
import WooTabsScroll from "./Components/WooTabsScroll";
import MoreLess from "./Components/MoreLess";
import Modal from "./Components/Modal";
import SliderTextProductStrengths from "./Components/Slides/SliderTextProductStrengths";
import LpVariant from "./Components/LpVariant";
import LpTabs from "./Components/LpTabs";
import WooCommerceArchiveScroll from "./Components/WooCommerceArchiveScroll";

class Core {
  
  constructor() {
    new SetVH();
    new TriggerElement();
    new SliderHeaderHero();
    new SliderStepByStep();
    new SliderBlogBanner();
    new SliderRecommendedProducts();
    new SliderCompareProducts();
    new SliderPosts();
    new SliderTextProductStrengths();
    new Header();
    new Menu();
    new Toggle();
    new Faq();
    new Dropdown();
    new WooTabsScroll();
    new Tabs();
    new VideoPlayer();
    new ScrollNextSection();
    new SearchSuggest();
    // new Timeline();
    new MenuProducts();
    new MenuMobile();
    new FormSuccess();
    new ScrollTop();
  
    new ChangeLink();
    new LoadMore();
    new CompareProducts();
    new CompareProductsMobile();
    new CompareProductButton();
    new AddToCart();
    // new ColorPreview();
    new App();
    new Configurator();
    new RemoveProductCart();
    new MoreLess();
    new Modal();
    new LpVariant();
    new LpTabs();

    new WooCommerceArchiveScroll();
  }
}

new Core();
